import assetRegistry from '@dialogexe/cw-asset-provider/core/AssetRegistry';

assetRegistry.register('kinoklubb-black', require('./img/kinoklubb-black.png'));
assetRegistry.register('eblogo', require('./img/eblogo.png'));
assetRegistry.register('app-store', require('./img/app-store.png'));
assetRegistry.register('google-play', require('./img/google-play.png'));
assetRegistry.register('filmGrail', require('./img/filmgrail.png'));
assetRegistry.register('fredrikstadkino', require('./img/fredrikstadkino.png'));
assetRegistry.register('landscapeImagePlaceholder', require('./img/landscapeImagePlaceholder.png'));